"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "131jtor",
  styles: "span{border-radius:2px;}"
} : {
  name: "1353n0g-subtle",
  styles: "span{border-radius:2px;};label:subtle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)("display:inline-flex;align-items:center;vertical-align:middle;font-size:14px;line-height:20px;user-select:none;cursor:pointer;position:relative;input{position:absolute;opacity:0;pointer-events:none;&:checked~span{background-color:", theme.primary, ";border-color:", theme.primary, ";}&:checked~span:after{display:block;}&:focus-visible~span{border-color:", theme.primary5darker, ";}&:focus-visible~span:before{opacity:0.2;}}span{position:relative;top:0;left:0;height:16px;min-width:16px;border:2px solid ", theme.border, ";cursor:pointer;margin-right:7px;&:before{content:'';position:absolute;background:", theme.primary, ";opacity:0;left:-10px;top:-10px;width:35px;height:35px;border-radius:50%;transition:opacity 250ms;}&:hover:before{opacity:0.1;}&:after{content:'';position:absolute;display:none;left:5px;top:2px;width:4px;height:9px;border:solid white;border-width:0 2px 2px 0;transform:rotate(45deg);}}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  nomargin: process.env.NODE_ENV === "production" ? {
    name: "1wcfv52",
    styles: "margin-right:0"
  } : {
    name: "fjihzo-nomargin",
    styles: "margin-right:0;label:nomargin;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  child: process.env.NODE_ENV === "production" ? {
    name: "11n8o9i",
    styles: "padding-left:41px;span{left:16px;}"
  } : {
    name: "1nm3eds-child",
    styles: "padding-left:41px;span{left:16px;};label:child;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  disabled: (theme, state) => /*#__PURE__*/(0, _react.css)("color:", theme.subtleText, ";cursor:", state ? state : 'not-allowed', ";span{opacity:0.5;cursor:", state ? state : 'not-allowed', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:disabled;")),
  subtle: theme => _ref
};
var _default = exports.default = styles;